var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRightArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m1.5 13.5 9-5.5-9-5.5v11ZM.766 1.19a1.503 1.503 0 0 1 1.515.029l9 5.5a1.5 1.5 0 0 1 0 2.563l-9 5.5a1.496 1.496 0 0 1-1.515.027A1.503 1.503 0 0 1 0 13.5v-11c0-.543.294-1.043.766-1.308Z"
})));
export default SvgRightArrowIcon;